import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import GlobalSnackbar from "../../../shared/utils/GlobalSnackbar";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Swal from "sweetalert2";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import CapitalizeFirstLetter from "../../../shared/utils/CapitalizeFirstLetter";
import Decrypt from "../../../shared/utils/Decrypt";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Sync } from "@mui/icons-material";

import { FormControl, InputLabel, Select, Menu, MenuItem } from "@mui/material";
import { CircularProgress, Tooltip, IconButton } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import axios from "axios";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Styles from "../../../styles/vendorDashboard.module.css";
import FormatDateTimestamp from "../../../helperFunctions/FormatDateTimestamp";
import ItemMasterForm from "./itemMasterForm";
import itemMasterViewModal from "./itemMasterViewModal";
import CustomLoading from "../../../shared/utils/CustomLoading";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

import { User_plus } from "../../../shared/assets/icons/index";
import styles from "../../../styles/adminPortal.module.css";
import ItemMasterViewModal from "./itemMasterViewModal";
import capitalizeWords from "../../../helperFunctions/capitalizedWords";
import GlobalButton from "../../../shared/utils/GlobalButton";

function EnhancedTableHead(props) {
  let role = localStorage.getItem("role");

  const hasActiveFilters = Object.values(props.searchInputs || {}).some(
    (value) => value && value.toString().trim() !== "",
  );

  return (
    <TableHead className={styles.tableHead}>
      <TableRow>
        {props.headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            className={styles.tableCell}
            sx={{
              minWidth: headCell.width,
            }}
          >
            <span className={styles.headCellHeading}>{headCell.label} </span>
            <div className={styles.topBorderDiv}>
              {["category", "productType", "source"].includes(headCell.id) && (
                <input
                  type="text"
                  className={styles.searchInput}
                  placeholder={`Search`}
                  onChange={(e) => props.handleSearchChangeHead(e, headCell.id)}
                  value={props.searchInputs?.[headCell.id] || ""}
                />
              )}
            </div>
          </TableCell>
        ))}
      </TableRow>

      {/* Only show count when there are active filters AND filteredIPCount > 0 */}
      {props.filteredIPCount > 0 && hasActiveFilters && (
        <TableRow>
          <TableCell
            colSpan={props.headCells.length}
            sx={{
              backgroundColor: "#DEEBFF",
              position: "relative",
              paddingBottom: "2rem",
            }}
          >
            <div className="fixed left-1/2 transform -translate-x-1/2 text-sm font-medium">
              {`${props.filteredIPCount} Items`}
            </div>
          </TableCell>
        </TableRow>
      )}
    </TableHead>
  );
}

function EnhancedTableToolbar(props) {
  const [rotate, setRotate] = useState(false);

  const handleOpen = (e) => {
    props.OnModalOpen(true);
    props.setSelectedItemData({});
  };

  const handleClickRefresh = () => {
    // Clean all filters
    props.setSearchInputs({
      category: "",
      productType: "",
    });

    setRotate(true);
    props.userVenderData();
    props.setPageSize(100);
    setTimeout(() => setRotate(false), 500);
  };

  return (
    <div className="border-b flex justify-between items-center h-14 pt-2">
      <div className="font-bold text-md text-gray-600">
        Total Items: {props.totalCount}
      </div>
      <div className="flex justify-center gap-1 items-center">
        <GlobalButton
          variant="contained"
          onClick={props.handleSyncItems}
          startIcon={<Sync />}
          sx={{
            backgroundColor: "#1976d2",
            color: "#fff",
            fontWeight: 600,
            fontSize: "14px",
            textTransform: "none",
            borderRadius: "8px",
            padding: "3px 10px",
            height: "35px",
            boxShadow: "0 3px 8px rgba(25, 118, 210, 0.25)",
            transition: "all 0.2s ease",

            "&:hover": {
              backgroundColor: "#1565c0",
              boxShadow: "0 5px 12px rgba(25, 118, 210, 0.35)",
              transform: "translateY(-1px)",
            },

            "&:active": {
              transform: "translateY(0)",
            },

            "& .MuiButton-startIcon": {
              marginRight: "6px",
            },
          }}
        >
          Sync Items
        </GlobalButton>

        <Tooltip title="Manage Categories">
          <IconButton onClick={props.onOpenCategoryModal}>🗂</IconButton>
        </Tooltip>

        {localStorage.getItem("role") != "1" && (
          <Tooltip title="Add Item">
            <IconButton onClick={handleOpen}>
              <User_plus sx={{ color: "#666666" }} />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </div>
  );
}
var oldData = [];
export default function EnhancedTable() {
  // Declare states
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImage, setIsImage] = useState(false);
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [details, setDetails] = useState(null);
  const [pageSize, setPageSize] = useState(100);
  const pageSizeOptions = [1, 5, 10, 50, 100, 200];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const serverURL = process.env.REACT_APP_URL;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemModalOpen, setItemModalOpen] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [isMapState, setIsMapState] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  const [filteredIPCount, setFilteredIPCount] = useState(0);
  const [item, setItem] = useState([]);

  const [selectedItemData, setSelectedItemData] = useState({});
  const [itemListLoading, setItemListLoading] = useState(true);
  const [totalItems, setTotalItems] = useState("0");
  let debounceTimeout = null;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null); // Store the selected row ID
  const [searchInputs, setSearchInputs] = useState({
    category: "",
    productType: "",
  });

  const refreshWithCurrentFilters = async () => {
    const queryParams = new URLSearchParams();

    // Add all current search filters
    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue && searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    await getItemList(queryParams.toString());
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [headCells, setHeadCells] = useState([]);

  useEffect(() => {
    const baseHeadCells = [
      { id: "itemid", label: "Item ID", width: 180 },
      { id: "category", label: "Category", width: 180 },
      { id: "productType", label: "Product Type", width: 180 },
      { id: "unitName", label: "Unit Name", width: 180 },
      { id: "price", label: "Price", width: 180 },
      { id: "fabricationDetail", label: "Fabrication", width: 200 },
      { id: "electricalDetail", label: "Electrical", width: 200 },
      { id: "printingDetail", label: "Printing", width: 200 },
      { id: "description", label: "Description", width: 250 },
      { id: "source", label: "Source", width: 250 },
      { id: "createdAt", label: "Created On", width: 160 },
      { id: "action", label: "Action", width: 80 },
    ];

    setHeadCells(baseHeadCells);
  }, []);

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const getItemList = async (queryParams) => {
    const token = localStorage.getItem("token");

    const res = await axios.get(`${serverURL}/itemMaster?${queryParams}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setItem(res.data.data); // reuse state
    setTotalCount(res.data.totalItemCount);
    setTotalPages(res.data.totalPages || 1);
    setItemListLoading(false);
  };

  useEffect(() => {
    // Only filter if both dates are set
    if (searchInputs.fromDate && searchInputs.toDate) {
      const queryParams = new URLSearchParams();
      Object.entries(searchInputs).forEach(([key, value]) => {
        if (value && value.trim() !== "") {
          queryParams.append(key, value);
        }
      });
      queryParams.append("page", 1);
      queryParams.append("limit", pageSize);
      fetchItems(queryParams.toString());
    }
  }, [searchInputs.fromDate, searchInputs.toDate]);

  useEffect(() => {
    getItemList(page, pageSize);
  }, []);

  const handleModalOpen = (value) => {
    setIsModalOpen(value);
  };

  const handleEditModal = (e, v, operation) => {
    setIsActionLoading(true);
    setAnchorEl(null);
    axios
      .get(`${serverURL}/itemMaster/${v._id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Decrypt email and phone number
          let itemData = response.data.data;
          itemData = {
            ...itemData,
            emailAddress: itemData.email,

            phoneNumber: itemData.phoneNumber,
          };

          // Set the decrypted data in state
          setSelectedItemData(itemData);

          // Handle modal based on the operation type
          if (operation === "edit") {
            setIsModalOpen(true);
          }
          setIsActionLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching UserPartner:", error);
        setIsActionLoading(false);
      });
  };

  const handleViewModal = (e, v, operation) => {
    setIsActionLoading(true);
    setAnchorEl(null);

    axios
      .get(`${serverURL}/itemMaster/${v}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          let itemData = response.data.data;

          // Decrypt email and phone number
          itemData = {
            ...itemData,
            emailAddress: itemData.email,

            phoneNumber: itemData.phoneNumber,
          };

          // Set the decrypted data
          setSelectedItemData(itemData);

          // Handle modal based on the operation type
          if (operation === "read") {
            setItemModalOpen(true);
          }

          setIsActionLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching user:", error);
        setIsActionLoading(false);
      });
  };

  const handleDelete = (e, v) => {
    e.preventDefault();
    setAnchorEl(null);

    Swal.fire({
      icon: "error",
      text: "Do you want to delete?",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          axios
            .delete(`${serverURL}/itemMaster/${v._id}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            })
            .then((response) => {
              setSnackbar({
                open: true,
                message: response.data.message,
                severity: "success",
              });
              refreshWithCurrentFilters();
            })
            .catch((error) => {
              console.error("Error deleting User:", error);
              Swal.fire("There was an error deleting the User.");
            });
        } catch (error) {
          console.error(error);
          Swal.fire("There was an error deleting the User.");
        }
      } else if (result.isDenied) {
        Swal.fire("Changes are not deleted", "", "info");
      }
    });
  };

  const handlePageChange = async (e, value) => {
    setPage(value); // Update the page state

    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    queryParams.append("page", value);
    queryParams.append("limit", pageSize); // Assuming pageSize is the number of items per page
    await fetchItems(queryParams.toString()); // Fetch first page with new page size
  };

  const handlePageSizeChange = async (e) => {
    const newSize = parseInt(e.target.value, 10);
    setPageSize(newSize);

    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    // Add the new page and page size to the query params
    queryParams.append("page", 1);
    queryParams.append("limit", newSize);

    await fetchItems(queryParams.toString()); // Fetch first page with new page size
  };

  const handleIconOpen = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId); // Set the selected row ID
  };
  const handleIconClose = () => {
    setAnchorEl(null);
    setSelectedRowId(null); // Reset the selected row ID
  };

  const fetchItems = async (queryParams) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/itemMaster?${queryParams}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response?.data?.success) {
        setItem(response?.data?.data);
        setTotalPages(response?.data?.totalPages);
        setTotalCount(response?.data?.totalItemCount);
        setFilteredIPCount(response?.data?.totalRecords);
        setPage(response?.data?.currentPage);
      }
    } catch (error) {
      console.error("Error fetching filtered vendors:", error);
    } finally {
    }
  };

  const handleSearchChangeHead = async (e, key) => {
    const value = e.target.value.toLowerCase();

    setSearchInputs((prevState) => {
      const updatedInputs = { ...prevState, [key]: value };

      const allFieldsEmpty = Object.values(updatedInputs).every(
        (val) => val.trim() === "",
      );

      if (allFieldsEmpty) {
        getItemList(1, pageSize);
        setFilteredIPCount(0);
        return updatedInputs;
      }

      if (debounceTimeout) clearTimeout(debounceTimeout);

      let queryParams = new URLSearchParams();

      Object.entries(updatedInputs).forEach(([searchKey, searchValue]) => {
        if (searchValue.trim() !== "") {
          queryParams.append(searchKey, searchValue);
        }
      });

      queryParams.append("page", 1); // Current page
      queryParams.append("limit", pageSize); // Number of rows per page

      fetchItems(queryParams.toString());

      return updatedInputs;
    });
  };

  const handleViewClick = (e, id, option) => {
    handleViewModal(e, id, option);
  };
  const handleEditClick = (e, id, option) => {
    handleEditModal(e, id, "edit");
  };
  const handleCloneClick = (e, row) => {
    e.stopPropagation();

    // 🔥 shallow clone
    const clonedData = { ...row };

    // remove identifiers
    delete clonedData._id;
    delete clonedData.createdAt;
    delete clonedData.updatedAt;

    // optional
    clonedData.itemId = "";

    setSelectedItemData(clonedData);

    // open modal
    setIsModalOpen(true);
  };

  const handleRenameCategory = async (oldName) => {
    try {
      const { value: newName } = await Swal.fire({
        title: "Rename Category",
        input: "text",
        inputValue: oldName,
        showCancelButton: true,
        confirmButtonText: "Update",

        didOpen: () => {
          const el = document.querySelector(".swal2-container");
          if (el) {
            el.style.zIndex = "2000";
          }
        },

        inputValidator: (value) => {
          if (!value) {
            return "Category name is required";
          }

          if (value.trim().toLowerCase() === oldName.toLowerCase()) {
            return "New name must be different";
          }
        },
      });

      if (!newName) return;

      await axios.put(
        `${serverURL}/itemMaster/rename-category`,
        {
          oldName: oldName.trim(),
          newName: newName.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      setSnackbar({
        open: true,
        message: "Category renamed successfully",
        severity: "success",
      });

      getItemList();
    } catch (error) {
      console.error("Error renaming category:", error);

      const data = error.response?.data || {};
      const code = data.code;
      const message = data.error || data.message || "Error renaming category";

      if (code === "CATEGORY_ALREADY_EXISTS") {
        setSnackbar({
          open: true,
          message: "Category already exists. Please choose a different name.",
          severity: "error",
        });
        return;
      }

      setSnackbar({
        open: true,
        message,
        severity: "error",
      });
    }
  };

  const handleDeleteCategory = async (category) => {
    try {
      const result = await Swal.fire({
        icon: "warning",
        title: "Delete Category",
        text: `Are you sure you want to delete the "${category}" category? All products in this category will also be deleted.`,

        showCancelButton: true,
        confirmButtonText: "Delete",
        confirmButtonColor: "#d33",

        didOpen: () => {
          const el = document.querySelector(".swal2-container");
          if (el) {
            el.style.zIndex = "2000";
          }
        },
      });

      if (!result.isConfirmed) return;

      await axios.delete(
        `${serverURL}/itemMaster/delete-category/${category}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      setSnackbar({
        open: true,
        message: "Category deleted successfully",
        severity: "success",
      });

      getItemList();
    } catch (error) {
      console.error("Error deleting category:", error);

      setSnackbar({
        open: true,
        message: "Error deleting category",
        severity: "error",
      });
    }
  };
  const handleSyncItems = async () => {
    try {
      setItemListLoading(true);
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${serverURL}/itemMaster/getAllItemsFromTranzact`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      getItemList();

      // setItem(res.data.data?.item_master_data);
      // setTotalCount(res.data.data?.item_master_data?.length);
      // setTotalPages(res.data.totalPages || 1);
      // setItemListLoading(false);
    } catch (error) {
    } finally {
      setItemListLoading(false);
    }
  };
  return (
    <div className={styles.tableGround}>
      <Box>
        {!itemListLoading ? (
          <Paper
            sx={{ width: "100%", boxShadow: "none" }}
            className={styles.tableGap}
          >
            <EnhancedTableToolbar
              totalCount={totalCount}
              userVenderData={getItemList}
              setPageSize={setPageSize}
              OnModalOpen={(value) => handleModalOpen(value)}
              onSearchChange={(value) => handleSearchChangeHead(value)}
              totalItems={item}
              setSelectedItemData={setSelectedItemData}
              setSearchInputs={setSearchInputs}
              setIsMapState={setIsMapState}
              isMapState={isMapState}
              onOpenCategoryModal={() => setIsCategoryModalOpen(true)}
              handleSyncItems={handleSyncItems}
            />

            <>
              <TableContainer
                className={`${styles.tableContainer} ${Styles["custom-scrollbar"]}`}
              >
                <Table
                  stickyHeader
                  // sx={{ minWidth: 750 }}
                  className="rounded-lg "
                >
                  <EnhancedTableHead
                    rowCount={item?.length}
                    headCells={headCells}
                    userListData={getItemList}
                    setSearchInputs={setSearchInputs} // Function to update search inputs
                    handleSearchChangeHead={handleSearchChangeHead}
                    searchInputs={searchInputs}
                    filteredIPCount={filteredIPCount}
                  />

                  {item && item?.length > 0 ? (
                    <TableBody>
                      {item.map((v, index) => {
                        const role = localStorage.getItem("role");
                        return (
                          <TableRow
                            hover
                            className={styles.tableRowHead}
                            tabIndex={-1}
                            key={v._id}
                            onClick={(e) => {
                              handleViewClick(e, v._id, "read"); // Perform the intended action
                            }}
                          >
                            <TableCell>{v.itemId || "-"}</TableCell>
                            <TableCell>{v.category || "-"}</TableCell>
                            <TableCell>{v.productType || "-"}</TableCell>
                            <TableCell>{v.unitName || "-"}</TableCell>
                            <TableCell>
                              <Box display="flex" alignItems="center">
                                <CurrencyRupeeIcon
                                  sx={{
                                    fontSize: 16,
                                    mr: 0.5,
                                    color: "text.secondary",
                                  }}
                                />
                                {v.price || 0}
                              </Box>
                            </TableCell>
                            <TableCell>{v.fabricationDetail || "-"}</TableCell>
                            <TableCell>{v.electricalDetail || "-"}</TableCell>
                            <TableCell>{v.printingDetail || "-"}</TableCell>
                            <TableCell>{v.description || "-"}</TableCell>
                            <TableCell>{v.source ?? "Pixell"}</TableCell>
                            <TableCell>
                              <FormatDateTimestamp timestamp={v.createdAt} />
                            </TableCell>

                            {role != 1 && (
                              <TableCell
                                className={styles.tableRow}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div className="flex justify-center">
                                  <Tooltip title="Click">
                                    <IconButton
                                      onClick={(e) => handleIconOpen(e, v._id)}
                                    >
                                      <MoreVertIcon
                                        style={{
                                          color: "var(--primary-color)",
                                        }}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </div>
                                <Menu
                                  anchorEl={anchorEl}
                                  open={
                                    Boolean(anchorEl) && selectedRowId === v._id
                                  }
                                  onClose={handleIconClose}
                                  keepMounted
                                >
                                  {/* Details Section */}
                                  {isVerified && details && (
                                    <div style={{ marginTop: "2rem" }}>
                                      <h3>Details:</h3>
                                      <pre>
                                        {JSON.stringify(details, null, 2)}
                                      </pre>
                                    </div>
                                  )}

                                  <MenuItem
                                    onClick={(e) => {
                                      handleEditClick(e, v, "edit");
                                      handleIconClose(); // Close the menu
                                    }}
                                    disabled={isActionLoading}
                                  >
                                    <EditOutlinedIcon
                                      style={{ color: "#6b7280" }}
                                    />{" "}
                                    <p className="ml-2 font-semibold text-[#6b7280]">
                                      Edit
                                    </p>
                                  </MenuItem>
                                  <MenuItem
                                    onClick={(e) => {
                                      handleCloneClick(e, v);
                                      handleIconClose();
                                    }}
                                  >
                                    <User_plus style={{ color: "#6b7280" }} />
                                    <p className="ml-2 font-semibold text-[#6b7280]">
                                      Duplicate
                                    </p>
                                  </MenuItem>

                                  {localStorage.getItem("role") == "-1" && (
                                    <MenuItem
                                      onClick={(e) => handleDelete(e, v)}
                                    >
                                      <DeleteOutlinedIcon
                                        style={{ color: "red" }}
                                      />{" "}
                                      <p className="ml-2 font-semibold text-[red]">
                                        Delete
                                      </p>
                                    </MenuItem>
                                  )}
                                </Menu>
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={headCells?.length}
                        sx={{ borderBottom: "none" }}
                      >
                        <div className="flex justify-center items-center h-64">
                          No Item Found
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </Table>
              </TableContainer>
              <hr
                className="mt-2 bg-gray-200 "
                style={{ border: "0.5px solid var(--light-grey-color)" }}
              />

              <div className="flex items-center justify-between ">
                <FormControl
                  variant="standard"
                  size="small"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 1,
                    "& .MuiInputBase-root:before": { borderBottom: "none" },
                    "& .MuiInputBase-root:after": { borderBottom: "none" },
                    "& .MuiInputBase-root": { marginTop: 1 }, // 👈 override here
                  }}
                >
                  <InputLabel
                    id="page-size-label"
                    sx={{
                      position: "static",
                      transform: "none",
                      fontSize: "14px",
                      marginRight: "8px",
                      marginTop: "2px",
                    }}
                  >
                    Rows
                  </InputLabel>
                  <Select
                    labelId="page-size-label"
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    label="Rows"
                  >
                    {pageSizeOptions.map((size) => (
                      <MenuItem key={size} value={size}>
                        {size}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <GlobalSnackbar
                  snackbar={snackbar}
                  handleClose={handleSnackbarClose}
                />

                <Pagination
                  className="p-2 flex justify-center"
                  count={totalPages}
                  page={page}
                  onChange={handlePageChange}
                  sx={{
                    "& .MuiPaginationItem-root.Mui-selected": {
                      backgroundColor: "#418cff", // Blue background for selected
                      color: "#fff", // White text for selected
                    },
                    "& .MuiPaginationItem-root.Mui-selected:hover": {
                      backgroundColor: "#3366cc", // Darker blue on hover
                    },
                    "& .MuiPaginationItem-root": {
                      "&:hover": {
                        backgroundColor: "#ddd", // Light gray for hovered items
                      },
                    },
                  }}
                />
              </div>
            </>
          </Paper>
        ) : (
          <div className={styles.tableLoading}>
            <CircularProgress />
          </div>
        )}
      </Box>

      {isImage && (
        <Modal
          open={isImage}
          onClose={() => {
            setIsImage(false);
            setSelectedImage(null);
          }}
          className="flex items-center justify-center backdrop-blur-sm"
        >
          <div className="relative w-[500px] h-[450px] bg-[var(--disabled-color)] flex justify-center items-center">
            {/* MUI Close Icon */}
            <IconButton
              onClick={() => {
                setIsImage(false);
                setSelectedImage(null);
              }}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "white",
                bgcolor: "black",
                "&:hover": {
                  bgcolor: "gray",
                },
              }}
            >
              <CloseIcon />
            </IconButton>

            {selectedImage &&
              (selectedImage.endsWith(".pdf") ? (
                <embed
                  src={selectedImage}
                  type="application/pdf"
                  className="object-contain  min-w-[70%] min-h-[70%] max-w-[80%] max-h-[80%]"
                />
              ) : (
                <img
                  src={selectedImage}
                  alt="Certificate"
                  className="object-contain  min-w-[70%] min-h-[70%] max-w-[80%] max-h-[80%]"
                />
              ))}
          </div>
        </Modal>
      )}
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        isModalOpen && (
          <ItemMasterForm
            setSnackbar={setSnackbar}
            getItemList={refreshWithCurrentFilters}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            selectedItemData={selectedItemData}
          />
        )
      )}
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        itemModalOpen && (
          <ItemMasterViewModal
            setSnackbar={setSnackbar}
            getItemList={getItemList}
            itemModalOpen={itemModalOpen}
            setItemModalOpen={setItemModalOpen}
            selectedItemData={selectedItemData}
          />
        )
      )}
      <Modal
        open={isCategoryModalOpen}
        onClose={() => setIsCategoryModalOpen(false)}
        className="flex items-center justify-center"
        sx={{
          zIndex: 2000,
        }}
        disableEnforceFocus
      >
        <div
          style={{
            width: "520px",
            maxHeight: "70vh",
            overflowY: "auto",
            background: "#fff",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "16px",
            }}
          >
            <h2 style={{ fontSize: "18px", fontWeight: "600" }}>
              Manage Categories
            </h2>

            <IconButton onClick={() => setIsCategoryModalOpen(false)}>
              <CloseIcon />
            </IconButton>
          </div>

          {/* Category List */}

          {Object.values(
            item.reduce((acc, current) => {
              const key = current.category.trim().toLowerCase();

              if (!acc[key]) {
                acc[key] = {
                  displayName: current.category.trim(),
                  count: 0,
                };
              }

              acc[key].count++;

              return acc;
            }, {}),
          )
            .sort((a, b) =>
              a.displayName.localeCompare(b.displayName, undefined, {
                sensitivity: "base",
              }),
            )
            .map((cat) => {
              return (
                <div
                  key={cat.displayName}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    marginBottom: "10px",
                    background: "#fafafa",
                  }}
                >
                  {/* Left */}

                  <div>
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: "15px",
                      }}
                    >
                      {cat.displayName}
                    </div>

                    <div
                      style={{
                        fontSize: "12px",
                        color: "#6b7280",
                      }}
                    >
                      {cat.count} Products
                    </div>
                  </div>

                  {/* Right buttons */}

                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                    }}
                  >
                    <GlobalButton
                      variant="secondary"
                      size="small"
                      onClick={() => handleRenameCategory(cat.displayName)}
                    >
                      {`Edit`}
                    </GlobalButton>

                    <GlobalButton
                      variant="warning"
                      size="small"
                      onClick={() => handleDeleteCategory(cat.displayName)}
                    >
                      {`Delete`}
                    </GlobalButton>
                  </div>
                </div>
              );
            })}
        </div>
      </Modal>
    </div>
  );
}
